import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { ROUTES } from "@/app/router";
import {
  markServerModalAsViewed,
  serverModalsQueriesStore,
} from "@/features/server-modals/api";
import { errorToast } from "@/shared/ui";

export const useServerModals = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { data: firstServerModal } = useQuery({
    ...serverModalsQueriesStore.list,
    select: (data) => data[0],
  });

  const markServerModalAsViewedMutation = useMutation({
    mutationFn: markServerModalAsViewed,
    onSuccess: () => {
      void queryClient.invalidateQueries(serverModalsQueriesStore.list);
    },
    onError: errorToast,
    onSettled: () => {
      navigate(firstServerModal?.callToActionUrl ?? ROUTES.HOME);
    },
  });

  const closeServerModal = () => {
    if (!firstServerModal) {
      return;
    }

    markServerModalAsViewedMutation.mutate([firstServerModal.id]);
  };

  return {
    firstServerModal,
    isClosing: markServerModalAsViewedMutation.isPending,
    closeServerModal,
  };
};
